
define('app/dashboard/leagues/instances/views/scoringSettingsView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/userModel',
	'known/models/leagueInstanceModel',
	'known/models/productModel',
	
	//Templates
	'text!app/dashboard/leagues/instances/templates/scoringSettingTemplate.html'
], function(
		$, 
		_, 
		Backbone, 
		UserModel, 
		LeagueInstanceModel,
		ProductModel,
		scoringSettingHtml){
	var ScoringStatView = Backbone.View.extend({
		initialize: function(options) {
			this.lgInstance = options.lgInstance;
			this.statName = options.statName;
			this.event = options.event;
			
			var statScores = this.lgInstance.get("statScores");
			this.points = statScores != null ? statScores[this.statName] : "";
			
			this.scoringSettingTemplate = _.template(scoringSettingHtml.trim());
			
			this.buildEl();
			
			this.listenTo(this.event, 'editScoringSettings', this.editPoints);
		},
		
		buildEl: function() {			
			var desc = "";
			switch (this.statName) {
			case 'PASS_ATT':
				desc = "Passing Attempt";
				break; 			
			case 'PASS_COMP':
				desc = "Completion";
				break; 		
			case 'PASS_YDS':
				desc = "Passing Yards";
				break; 				
			case 'PASS_TDS':
				desc = "Passing TD";
				break; 		
			case 'PASS_INTS':
				desc = "Interception";
				break; 	
			case 'RUSH_ATT':
				desc = "Rushing Attempt";
				break; 			
			case 'RUSH_YDS':
				desc = "Rushing Yards";
				break; 				
			case 'RUSH_TDS':
				desc = "Rushing TD";
				break; 		
			case 'REC':
				desc = "Reception";
				break;							
			case 'REC_YDS':
				desc = "Receiving Yards";
				break;				
			case 'REC_TDS':
				desc = "Receiving TD";
				break;			
			case 'FUMBLE':
				desc = "Fumble";
				break;						
			case 'K_FGM':
				desc = "FG Made";
				break;					
			case 'K_MISS':
				desc = "FG Missed";
				break;
			case 'K_XP':
				desc = "XP Kicked";
				break;				
			case 'DEF_SACK':
				desc = "Sack";
				break;			
			case 'DEF_FR':
				desc = "Fumble Recovery";
				break;	
			case 'DEF_INT':
				desc = "Interception";
				break;		
			case 'DEF_TD':
				desc = "Defensive TD";
				break;		
			case 'DEF_SFTY':
				desc = "Safety";
				break;			
			case 'DEF_PA_0':
				desc = "0 Points Allowed";
				break;
			case 'DEF_PA_6':
				desc = "1-6 Points Allowed";
				break;
			case 'DEF_PA_13':
				desc = "7-13 Points Allowed";
				break;
			case 'DEF_PA_20':
				desc = "14-20 Points Allowed";
				break;
			case 'DEF_PA_27':
				desc = "21-27 Points Allowed";
				break;
			case 'DEF_PA_34':
				desc = "28-34 Points Allowed";
				break;
			case 'DEF_PA_45':
				desc = "35+ Points Allowed";
				break;
			case 'DEF_YA_100':
				desc = "Under 100 Yards Allowed";
				break;
			case 'DEF_YA_200':
				desc = "100-199 Yards Allowed";
				break;
			case 'DEF_YA_300':
				desc = "200-299 Yards Allowed";
				break;
			case 'DEF_YA_400':
				desc = "300-399 Yards Allowed";
				break;
			case 'DEF_YA_500':
				desc = "400-499 Yards Allowed";
				break;
			case 'DEF_YA_600':
				desc = "500+ Yards Allowed";
				break;
			case 'IDP_TK':
				desc = "Tackle";
				break;					
			case 'IDP_ASSIST':
				desc = "Tackle Assist";
				break;		
			case 'IDP_SACK':
				desc = "Sack";
				break;					
			case 'IDP_PADEF':
				desc = "Pass Defensed";
				break;		
			case 'IDP_INT':
				desc = "Inteception";
				break;			
			case 'IDP_FF':
				desc = "Forced Fumble";
				break;				
			case 'IDP_FR':
				desc = "Fumble Recovery";
				break;			
			case 'TM_WINS':
				desc = "Team Win";
				break;					
			case 'TM_LOSSES':
				desc = "Team Loss";
				break;				
			case 'PUNTS':
				desc = "Punt";
				break;							
			case 'PUNT_YDS':
				desc = "Punt Yards";
				break;				
			case 'PUNT_RETYD':
				desc = "Punt Return Yards";
				break;	
			case 'PUNT_INS20':
				desc = "Punt Inside 20";
				break;
			default:
				break;
			}
			
			this.setElement($(this.scoringSettingTemplate({
				stat: this.statName,
				statCategory: desc,
				points: this.points})));
			
			if(desc == null || desc == "" || this.points == null || this.points == ""){
				$(this.el).hide();
			} else if(this.points == "0" && this.statName.indexOf('DEF_PA_') == -1){
				$(this.el).find('b').css("text-decoration", "line-through");
			}
		},
		
		editPoints: function() {
			$(this.el).find('.scoringPointsValue').hide();
			$(this.el).find('.editScoringPointsInput').show();
		},
		
		hideEditPoints: function() {
			$(this.el).find('.editScoringPointsInput').hide();
			$(this.el).find('.scoringPointsValue').show();			
		},
		
		destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
	    	
	    	//Remove DOM
	    	$(this.el).removeData().unbind();
	    	this.remove();  
	    	Backbone.View.prototype.remove.call(this);
        }
	});
	
	var ScoringSectionView = Backbone.View.extend({
		initialize: function(options) {
			this.lgInstance = options.lgInstance;
			this.statList = options.statList;
			this.sectionName = options.sectionName;
			this.event = options.event;
			
			this.scoreRowViews = [];
			
			this.setElement($('<div class="controls" style="display:none;"></div>'));
			
			this.listenTo(this.event, 'changeSection', this.changeActiveSection);
		},
		
		render: function () {
			this.removeAllStats();
			$(this.el).empty();
			this.addAllStats();
			$(this.el).hide();
			
			return this;
		},
		
		addStat: function(stat) {
			var view = new ScoringStatView({
				lgInstance: this.lgInstance,
				statName: stat,
				event: this.event});
			//this.listenTo(team, 'change:draftPosition', this.orderChange);
			$(this.el).append(view.render().el);
			this.scoreRowViews[stat] = view;
		},
		
		removeStat: function(stat) {
			//this.stopListening(team, 'change:draftPosition', this.orderChange);
			this.scoreRowViews[stat].destroyView();
			delete this.scoreRowViews[stat];
		},
		
		addAllStats: function() {
			for (var i = 0; i < this.statList.length; i++) {
				this.addStat(this.statList[i]);
			}
		},
		
		removeAllStats: function() {
			_.each(this.scoreRowViews, function(view, key){
				this.scoreRowViews[key].destroyView();
				delete this.scoreRowViews[key];
			}, this);
		},
		
		changeActiveSection: function(sectionName) {
			if(this.sectionName == sectionName){
				$(this.el).show();
			} else {
				$(this.el).hide();
			}
		},
		
		destroyView: function() {
			this.removeAllStats();
			
	    	this.stopListening();
	    	this.undelegateEvents();
	    	
	    	//Remove DOM
	    	$(this.el).removeData().unbind();
	    	this.remove();  
	    	Backbone.View.prototype.remove.call(this);
        }
	});
	
	var ScoringSettingsView = Backbone.View.extend({
		el: $("#scoringGrp"),
		
		initialize: function(options) {
			this.userModel = options.userModel; 
			this.lgInstance = options.lgInstance; 
			this.prodModel = options.prodModel;
			this.prodConfig = options.prodConfig;
			
			this.prodType = this.prodModel.get('productTypes').get(this.lgInstance.get("prodId"));
			this.event = _.extend({}, Backbone.Events);
			
			_.bindAll(this, 'changeSection');
			_.bindAll(this, 'editScoringSettings');
			
			this.sectionContainer = $(this.el).find('#scoringSectionList');
			this.sectionViews = {};
			
			this.listenTo(this.event, 'editScoringSettings', this.editForm);
		},
		
		render: function () {
			this.removeAllSections();
			this.sectionContainer.empty();
			this.$(".scoringSectionSelInput").empty();
			this.addAllSections();
			
			this.updateVisuals();
			
			this.changeSection();
			this.$(".scoringSectionSelInput").on('change', this.changeSection);
			this.$("#scoringEditBtn").on('click', this.editScoringSettings);
			
			return this;
		},
		
		updateVisuals: function() {
			if(this.lgInstance.isCommissioner(this.userModel.get('userName'))
					&& this.prodConfig.CUSTSCORING == 'true'
					&& this.lgInstance.get("draftStatus") != "COMPLETED"
					&& this.prodType.get('active')){
				$(this.el).find('#scoringEditBtn').show();
				$(this.el).find('#scoringFooter').hide();
			} else {
				$(this.el).find('#scoringEditBtn').hide();
				$(this.el).find('#scoringFooter').hide();
			}
			
			if(this.lgInstance.isCommissioner(this.userModel.get('userName'))
					&& this.prodConfig.CUSTSCORING == 'false'
					&& this.lgInstance.get("draftStatus") != "COMPLETED"
					&& this.prodType.get('active')){
				$(this.el).find('.scoringUpgradeNote').show();
			} else {
				$(this.el).find('.scoringUpgradeNote').hide();
			}
		},
		
		editForm: function() {
			$(this.el).find('#scoringEditBtn').hide();
			$(this.el).find('#scoringFooter').show();
		},
		
		editScoringSettings: function() {
			this.event.trigger("editScoringSettings");
		},
		
		changeSection: function() {
			var section = $(".scoringSectionSelInput").val();
			this.event.trigger("changeSection", section);
		},
		
		addSection: function(sectionName, dispName, statList, selected) {
			var view = new ScoringSectionView({
				lgInstance: this.lgInstance,
				statList: statList,
				sectionName: sectionName,
				event: this.event});
			//this.listenTo(team, 'change:draftPosition', this.orderChange);
			this.sectionContainer.append(view.render().el);
			//view.resetLeagues();
			this.sectionViews[sectionName] = view;
			
			var optionStart = "<option value=\"";
			var optionMiddle = "\" >";
			var optionEnd = "</option>";
			
			var selectedHtml = selected ? "\" selected=\"true" : "";
			
			this.$(".scoringSectionSelInput").append(optionStart + sectionName + selectedHtml	+ optionMiddle + dispName + optionEnd);
		},
		
		removeSection: function(sectionName) {
			//this.stopListening(team, 'change:draftPosition', this.orderChange);
			this.sectionViews[sectionName].destroyView();
			delete this.sectionViews[sectionName];
		},
		
		addAllSections: function() {
			if(this.lgInstance.get('prodLeagueName') == 'NFL'){
				this.addSection(
						'OFFENSE', 
						'Offense',
						['PASS_YDS','PASS_TDS','PASS_INTS','PASS_COMP','PASS_ATT','RUSH_YDS','RUSH_TDS','RUSH_ATT','REC_YDS','REC_TDS','REC','FUMBLE'],
						true);
				this.addSection(
						'DEFENSE', 
						'Defense',
						['DEF_SACK','DEF_FR','DEF_INT','DEF_TD','DEF_SFTY','DEF_PA_0','DEF_PA_6','DEF_PA_13','DEF_PA_20','DEF_PA_27','DEF_PA_34','DEF_PA_45'],
						false);
				this.addSection(
						'KICKING', 
						'Kicking',
						['K_FGM','K_MISS','K_XP'],
						false);
				this.addSection(
						'IDP', 
						'IDP',
						['IDP_TK','IDP_ASSIST','IDP_SACK','IDP_PADEF','IDP_INT','IDP_FF','IDP_FR'],
						false);
				this.addSection(
						'COACH',
						'Coach',
						['TM_WINS','TM_LOSSES'],
						false);
				this.addSection(
						'PUNTING', 
						'Punting',
						['PUNTS','PUNT_YDS','PUNT_RETYD','PUNT_INS20'],
						false);
			}
			
			$(this.el).find('.styled').uniform({radioClass: 'choice', selectAutoWidth: false});
		},
		
		removeAllSections: function() {
			_.each(this.sectionViews, function(view, key){
				this.sectionViews[key].destroyView();
				delete this.sectionViews[key];
			}, this);
		}
	});
	
	return ScoringSettingsView;  
});